import React, {useEffect, useState} from 'react';
import WeChatApplicationList from "./components/WeChatApplicationList";
import {HttpStatus} from "../../../modules/common/enums/HttpStatus";
import {WeChatApplicationDto} from "../../../modules/wechat/dto/WeChatApplicationDto";
import {useIntl} from "react-intl";
import {WeChatApplicationApi} from "../../../modules/wechat/api/WeChatApplicationApi";

const Index: React.FC = () => {
    const intl = useIntl();
    const [wechatApplicationList, setWechatApplicationList] = useState<Array<WeChatApplicationDto>>([]);

    useEffect(() => {
        fetchWechatApplicationList();
    }, []);

    const fetchWechatApplicationList = async () => {
        const responseResult = await WeChatApplicationApi.getWeChatApplicationList();
        if (responseResult.status === HttpStatus.SUCCESS) {
            setWechatApplicationList(responseResult.data);
        }
    };

    return (
        <div>
            <WeChatApplicationList wechatApplicationList={wechatApplicationList}
                                   onRefresh={fetchWechatApplicationList}/>
        </div>
    );
};

export default Index;
